export const projects = [
    {
        'id': 'gourmet_hound',
        'title' : 'Gourmet Hound',
        'description' : 'Built an ecommerce app for Gourmet Hound, a Fulham deli, with Headless WordPress and Next.js, including product catalogue, shopping basket, and responsive layout for local customers',
        'mission' :'My mission was to adapt both the frontend and backend of the web application using Next.js for the client interface and Strapi as the headless CMS and API.',
        'url':'https://gourmet-hound.vercel.app/',
        'url_github':'https://github.com/realejandro/gourmet_hound',
        'skills':['Next.js', 'Wordpress', 'GraphQL'],
        'role':'Full Stack Developer'
    },
    {
        'id': "weather_app",
        'title' : 'WeatherApp',
        'description' : 'Built a weather app with real-time API data, enabling city search, condition icons, clean UI, and dynamic temperature display.',
        'mission' :"Create an UI that show the weather and forecast. Create a documentation explaining how this works. Create api to organize the history of searches from the user",
        'url':'https://weather-app-9eii.onrender.com/',
        'url_github':'https://github.com/realejandro/weather_app',
        'skills':['react.js', 'typescript'],
        'role':'Full Stack Developer'
    },
    {
        'id': 'cli',
        'title' : 'CLI logistic company',
        'description' : 'Developed a CLI-based Employee Management System with Node.js, PostgreSQL, and Inquirer to manage employees, roles, and departments.',
        'mission' :'In this project I created a full stack testing framework for the mobile app and the web application to study the functionalities in this architecture',
        'url':'https://github.com/realejandro/cms-sql',
        'url_github':'https://github.com/realejandro/cms-sql',
        'skills':['typescript', 'node.js', 'SQL'],
        'role':'Back-end Developer'
    },    
    {
        'id': 'kanba_app',
        'title' : 'Kanba',
        'description' : "Built a full-stack Kanban board with JWT auth, custom login, secure backend, and Render deployment for agile task management.",
        'mission' :"To build a secure, full-stack Kanban board that enables authenticated users to manage tasks efficiently, demonstrating modern web development practices with JWT-based authentication, scalable API integration, and seamless deployment.",
        'url':'https://kanba-app.onrender.com/',
        'url_github':'https://github.com/realejandro/kanba-app',
        'skills':['React.js', 'typescript', 'SQL'],
        'role':'Full Stack Developer'
    },
    {
        'id': 'bookstorage_app',
        'title' : 'BookStorage App',
        'description' : "Built a Book Search Engine with login/signup, using Google Books API. Users can search, save, view, and remove books from their account.",
        'mission' :"To build a secure, full-stack Kanban board that enables authenticated users to manage tasks efficiently, demonstrating modern web development practices with JWT-based authentication, scalable API integration, and seamless deployment.",
        'url':'https://my-book-storage.onrender.com/',
        'url_github':'https://github.com/realejandro/my-book-storage',
        'skills':['MERN stack', 'typescript', 'graphQL'],
        'role':'Full Stack Developer'
    },
    {
        'id': 'propfolio',
        'title' : 'Propfolio',
        'description' : "Developed Propfolio, a web app for property owners with signup, login, and tools to track and manage inventory.",
        'mission' :"To build a secure, full-stack Kanban board that enables authenticated users to manage tasks efficiently, demonstrating modern web development practices with JWT-based authentication, scalable API integration, and seamless deployment.",
        'url':'https://real-state-portfolio.onrender.com/',
        'url_github':'https://github.com/realejandro/propfolio?tab=readme-ov-file',
        'skills':['MERN stack', 'typescript', 'graphQL'],
        'role':'Full Stack Developer'
    },
    {
        'id': 'etsy',
        'title' : 'Rewards platform',
        'description' : "Testing framework from scratch Fixed currency handling issues in a Rewards & Gift Cards API to ensure proper support for specific currencies.",
        'mission' :"To build a secure, full-stack Kanban board that enables authenticated users to manage tasks efficiently, demonstrating modern web development practices with JWT-based authentication, scalable API integration, and seamless deployment.",
        'url':'https://planet-frost-acd.notion.site/45e6c84aeb1a47fb9287ae7f0bdf8954?v=b3bbca2a8acc4767bb62242a8c0b8bf0',
        'url_github':'https://github.com/lucian1333/TenaciousTigersEtsyGiftCards/tree/main',
        'skills':['java', 'selenium', 'cucumber'],
        'role':'QA Automation Engineer'
    },
    {
        'id': 'owner',
        'title' : 'The Owner App',
        'description' : 'Built a real estate platform to connect landlords, tenants, and owners with dynamic forms and messaging tools.',
        'mission' :'My mission in this project was to create a Full Stack Testing Framework From Scratch and create test scripts to ensure that all currency exchange system is working',
        'url':'',
        'url_github':'',
        'skills':['Laravel', 'PHP', 'SQL'],
        'role':'Software Developer'
    }, 


]

